import { ApplicationBrandList, ApplicationBrandSummary, ApplicationModelList, ApplicationModelSummary, ProductApplicationList, } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchApplicationBrands = async (status, signal) => {
    const query = status === undefined ? '' : `?status=${status}`;
    return ApplicationBrandList.parse(await request(`/api/v1/applications/brands${query}`, { signal }));
};
export const createApplicationBrand = async (input) => ApplicationBrandSummary.parse(await request('/api/v1/applications/brands', {
    method: 'POST',
    body: input,
}));
export const updateApplicationBrand = async (id, input) => {
    await request(`/api/v1/applications/brands/${id}`, {
        method: 'PATCH',
        body: input,
    });
};
export const fetchApplicationModels = async (query = {}, signal) => {
    const params = new URLSearchParams();
    if (query.brandId !== undefined)
        params.set('brandId', query.brandId);
    if (query.search !== undefined && query.search !== '') {
        params.set('search', query.search);
    }
    if (query.limit !== undefined)
        params.set('limit', String(query.limit));
    const encoded = params.toString();
    return ApplicationModelList.parse(await request(`/api/v1/applications/models${encoded.length > 0 ? `?${encoded}` : ''}`, { signal }));
};
export const createApplicationModel = async (input) => ApplicationModelSummary.parse(await request('/api/v1/applications/models', {
    method: 'POST',
    body: input,
}));
export const updateApplicationModel = async (id, input) => {
    await request(`/api/v1/applications/models/${id}`, {
        method: 'PATCH',
        body: input,
    });
};
/** What one product fits. */
export const fetchProductApplications = async (productId, signal) => ProductApplicationList.parse(await request(`/api/v1/applications/products/${productId}`, { signal }));
export const linkProductApplication = async (productId, input) => {
    await request(`/api/v1/applications/products/${productId}`, {
        method: 'POST',
        body: input,
    });
};
export const unlinkProductApplication = async (productId, modelId) => {
    await request(`/api/v1/applications/products/${productId}/${modelId}`, {
        method: 'DELETE',
    });
};
//# sourceMappingURL=applications.js.map